import { Component, OnInit, ElementRef } from '@angular/core';
import { PageBase, CustomerInfo } from 't4core';
import { NavigationService, AnalyticsService } from 'app-components';
import { RentalAgreementComponent } from '../../dialogs/rental-agreement/rental-agreement.component';
import { AppSettingsService, AppIntegrationService } from 't4-app-integration';
import { BookingService } from 'app-components';

@Component({
    selector: 'app-setup-customer',
    templateUrl: './setup-customer.component.html',
    styleUrls: ['./setup-customer.component.css'],
    standalone: false
})
export class SetupCustomerComponent extends PageBase implements OnInit {
  public customer: CustomerInfo = null;
  public validCustomer = false;

  public hasGDPR: boolean = true;
  public confirmGDPR: boolean = false;
  public errGdpr: boolean = false;

  public labels: any = {
    title: '',
    gdpr: '',
    confirmGdpr:'',
    next:''
  };
  
  constructor(private navigator: NavigationService,
    el: ElementRef,
    private appSettings: AppSettingsService,
    private bookingService: BookingService,
    private analyticService: AnalyticsService,
    private appService: AppIntegrationService
  ) {
    super(el);
  }

  async ngOnInit() {

    // Skip if no sign in required
    if (this.Settings.clientSettings.RequireSignIn) {
      var token = this.UI.beginLoading("Intellitrailer.Booking.SetupCustomer.msgLoadingCustomer", "Loading customer", null);
      // Setup the customer
      var cus = await this.Api.get<CustomerInfo>("/Rental/FindCustomerByUser");
      if (!cus) cus = new CustomerInfo();

      this.bookingService.Query.Customer = cus;
      this.UI.loaderCompleted(token);
    }
    else {
      let state = this.bookingService.getBookingState();
      var cus = new CustomerInfo();
      cus.MobilePhone = state.booking.Customer.MobilePhone;
      cus.Email = state.booking.Customer.Email;
      this.bookingService.Query.Customer = cus;
    }

    // Skip if no customer settings
    if (!this.Settings.clientSettings.CustomerSettings) this.navigator.executeCommand("Next")

    // Skip i no visible fields other than Email & MobilePhone
    if (!this.Settings.clientSettings.CustomerSettings.Fields.some(x => x.FieldId != "Email" && x.FieldId != "MobilePhone" && x.Visible)) this.navigator.executeCommand("Next")

    //GPDR link if has GDPR terms
    this.hasGDPR = this.appSettings.settings.GDPRTerms ? true : false;


    this.customer = cus;

    this.labels.gdpr = 'GDPR';
    this.labels.title = await this.Translate.translate('turbo.core.RentalDialog.CustomerMyDetails', 'My details');
    this.labels.confirmGdpr = await this.Translate.translate('Intellitrailer.MyPage.ValidateAccount.ConfirmGDPR', 'I authorize the use of my personal data in compliance with GDPR.');
    this.labels.next = await this.Translate.translate('Intellitrailer.Navigation.Next', 'Next');
  }

  public async next(isFormValid: boolean) { // Validate
    if (this.hasGDPR && !this.confirmGDPR) {
      this.errGdpr = true;
      return;
    }
    else if (!isFormValid) {
      return;
    }
    await this.saveCustomer();

    this.navigator.executeCommand("Next");
  }

  public async showTerms() {
    this.Dialog.open(RentalAgreementComponent, { data: { agreementType: "GDPR" } });
  }

  private async saveCustomer(): Promise<boolean> {
    let userKeyPattern = await this.analyticService.getBrowserInfo();
    this.bookingService.Query.Customer.UserKey = userKeyPattern;
    let obj = await this.bookingService.saveCustomer(false);
    if (obj != null) {
      this.appService.setUserInfo();
    }
    return obj != null;
  }
}
